import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { LifeCycleStatus } from 'business/types';
import { snackbarService } from 'shared/lib/snackbar/service';
import { RQAPICallWithData } from 'store/APIClient';

import type { DataCatalogField, DataCatalogFieldTip } from '../types';

type UpdateDataCatalogFieldInput = {
    fieldName: string;
    description?: string | null;
    formula?: string | null;
    tips?: DataCatalogFieldTip[] | null;
    lifeCycleStatus?: LifeCycleStatus;
    statusAffectedSoftware?: string[];
    statusDescription?: string;
    statusEndDate?: string;
};

export const useAPIPutDataCatalogField = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({
            fieldName,
            ...body
        }: UpdateDataCatalogFieldInput) => {
            const response = await RQAPICallWithData<DataCatalogField>({
                endpoint: `data_catalog/field/${fieldName}`,
                method: 'PUT',
                body,
            });
            return response.content;
        },

        onSuccess: ({ data: updatedField, message }) => {
            snackbarService.showSuccess(message);
            queryClient.setQueryData<DataCatalogField[]>(
                ['data_catalog_fields'],
                (prev) =>
                    prev?.map((field) =>
                        field.field === updatedField.field
                            ? updatedField
                            : field,
                    ),
            );
        },
        meta: { useGlobalOnError: true },
    });
};
